import {
	CHANGE_LANGUAGE
} from '../actions/types';

const language = localStorage.getItem('translationLanguage') ? localStorage.getItem('translationLanguage') : 'en';

const INITIAL_STATE = {
    language
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case CHANGE_LANGUAGE:
			return {...state, language: action.payload};
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/reducers/LanguageReducer.js